"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread4 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectAssign = _interopRequireDefault(require("object-assign"));

var _abstractClient = _interopRequireDefault(require("./abstract-client"));

var AxiosClient =
/*#__PURE__*/
function (_AbstractClient) {
  (0, _inherits2["default"])(AxiosClient, _AbstractClient);

  function AxiosClient(axios, credentials) {
    var _this;

    var apiBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'https://api.classpass.com';
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, _classCallCheck2["default"])(this, AxiosClient);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AxiosClient).call(this, credentials, apiBase));

    if (!axios) {
      throw new Error('No axios instance provided');
    }

    _this.options = (0, _objectSpread4["default"])({
      timeout: 5000
    }, options);
    _this.axios = axios;
    return _this;
  }

  (0, _createClass2["default"])(AxiosClient, [{
    key: "sendRequest",
    value: function sendRequest(method, url, params, overrides) {
      var _objectSpread2;

      var headersToMerge;

      if (overrides && overrides.headers) {
        headersToMerge = (0, _objectSpread4["default"])({}, this.headers, overrides.headers);
        delete overrides.headers;
      } else {
        headersToMerge = this.headers;
      }

      var options = (0, _objectAssign["default"])({
        url: this.apiBase + url,
        method: method,
        timeout: this.options.timeout,
        responseType: 'text',
        headers: (0, _objectSpread4["default"])((_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, this.getAuthorizationHeaderName(), "Token ".concat(this.credentials.token)), (0, _defineProperty2["default"])(_objectSpread2, 'Content-Type', 'application/json'), _objectSpread2), headersToMerge),
        validateStatus: function validateStatus() {
          return true;
        } // don't reject on non-200 statuses

      }, {
        data: params
      }, overrides);
      return this.axios(options).then(function (response) {
        return {
          status: response.status,
          body: typeof response.data !== 'string' ? JSON.stringify(response.data) : response.data || '',
          headers: Object.keys(response.headers || {}).reduce(function (headers, field) {
            return (0, _objectSpread4["default"])({}, headers, (0, _defineProperty2["default"])({}, field.toLowerCase(), response.headers[field]));
          }, {})
        };
      })["catch"](function (error) {
        if (error && /timeout of [\d,]+ms exceeded/.test(error.message)) {
          return {
            wasNetworkTimeout: true
          };
        }

        throw error;
      });
    }
  }]);
  return AxiosClient;
}(_abstractClient["default"]);

exports["default"] = AxiosClient;